import { apiFetch } from "./client";
import type { Contact, ContactInput, ContactOwnerType, Page } from "./types";

export interface ContactListParams {
  limit?: number;
  offset?: number;
  owner_type?: ContactOwnerType;
  owner_id?: number;
}

export async function listContacts(
  params: ContactListParams = {},
): Promise<Page<Contact>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  if (params.owner_type) qs.set("owner_type", params.owner_type);
  if (params.owner_id !== undefined) qs.set("owner_id", String(params.owner_id));
  const query = qs.toString();
  return apiFetch(`/contacts${query ? `?${query}` : ""}`);
}

export async function createContact(data: ContactInput): Promise<Contact> {
  return apiFetch("/contacts", { method: "POST", body: JSON.stringify(data) });
}

export async function getContact(id: number): Promise<Contact> {
  return apiFetch(`/contacts/${id}`);
}

export async function updateContact(
  id: number,
  data: Partial<ContactInput>,
): Promise<Contact> {
  return apiFetch(`/contacts/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteContact(id: number): Promise<unknown> {
  return apiFetch(`/contacts/${id}`, { method: "DELETE" });
}
